/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPaymentTerms, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PaymentTermsController.
 */
export class PaymentTermsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /payment_terms:prefill
     */
    public createPrefilled(): Promise<Result<ApiPaymentTerms>> {
        return this.http.post<Result<ApiPaymentTerms>, undefined>('/payment_terms:prefill', undefined);
    }

    /**
     * Calls GET /payment_terms:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiPaymentTerms>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiPaymentTerms>>>('/payment_terms:query', query);
    }

    /**
     * Calls POST /payment_terms:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiPaymentTerms>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiPaymentTerms>>, ListRequest>('/payment_terms:query', listRequest, query);
    }

    /**
     * Calls POST /payment_terms/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiPaymentTerms>>> {
        return this.http.post<Result<LockedContextDto<ApiPaymentTerms>>, undefined>(`/payment_terms/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /payment_terms/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiPaymentTerms>> {
        return this.http.post<Result<ApiPaymentTerms>, undefined>(`/payment_terms/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /payment_terms/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiPaymentTerms[]>> {
        return this.http.post<Result<ApiPaymentTerms[]>, string[]>('/payment_terms/locks', ids);
    }

    /**
     * Calls POST /payment_terms/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/payment_terms/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /payment_terms/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/payment_terms/${primaryId}/locks`);
    }

    /**
     * Calls GET /payment_terms/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiPaymentTerms>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiPaymentTerms>>(`/payment_terms/${primaryId}`, query);
    }

    /**
     * Calls POST /payment_terms
     */
    public add(dto: ApiPaymentTerms): Promise<Result<ApiPaymentTerms>> {
        return this.http.post<Result<ApiPaymentTerms>, ApiPaymentTerms>('/payment_terms', dto);
    }

    /**
     * Calls PUT /payment_terms/{primaryId}
     */
    public update(dto: ApiPaymentTerms, primaryId: string): Promise<Result<ApiPaymentTerms>> {
        return this.http.put<Result<ApiPaymentTerms>, ApiPaymentTerms>(`/payment_terms/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /payment_terms
     */
    public putRange(dtos: ApiPaymentTerms[]): Promise<Result<ApiPaymentTerms[]>> {
        return this.http.patch<Result<ApiPaymentTerms[]>, ApiPaymentTerms[]>('/payment_terms', dtos);
    }

    /**
     * Calls DELETE /payment_terms/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/payment_terms/${primaryId}`);
    }

    /**
     * Calls POST /paymentterms:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiPaymentTerms>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiPaymentTerms>>, ListRequestWithIds>('/paymentterms:batch', listRequest, query);
    }
}
